import {ChecklistModelItemQuestion} from './checklistModelItemQuestion.model';

export class ChecklistModelItem {
    id: number;
    text: string;
    description: string;
    identifier: string;
    required: boolean;
    itemOrder: number;
    targetCompletionDays: number;
    overdueWeight: number;
    requiredConditionFormula: string;
    activeConditionFormula: string;
    visibilityConditionFormula: string;
    checklistModelItemGroupId: number;
    checklistModelItemQuestions: Array<ChecklistModelItemQuestion> = [];

    constructor(checklistModelItem: any) {
        if (checklistModelItem) {
            this.id = checklistModelItem.id;
            this.text = checklistModelItem.text;
            this.description = checklistModelItem.description;
            this.identifier = checklistModelItem.identifier;
            this.required = checklistModelItem.required;
            this.itemOrder = checklistModelItem.itemOrder;
            this.targetCompletionDays = checklistModelItem.targetCompletionDays;
            this.overdueWeight = checklistModelItem.overdueWeight;
            this.requiredConditionFormula = checklistModelItem.requiredConditionFormula;
            this.activeConditionFormula = checklistModelItem.activeConditionFormula;
            this.visibilityConditionFormula = checklistModelItem.visibilityConditionFormula;
            this.checklistModelItemGroupId = checklistModelItem.checklistModelItemGroupId;
            if (checklistModelItem.checklistModelItemQuestions) {
                checklistModelItem.checklistModelItemQuestions.forEach(checklistModelItemQuestion => {
                    this.checklistModelItemQuestions.push(new ChecklistModelItemQuestion(checklistModelItemQuestion));
                });
            }
        }
    }
}
